import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/$workspaceSlug/settings/")({
  component: SettingsHome,
});

function SettingsHome() {
  const params = Route.useParams();
  return <Navigate to="/$workspaceSlug/settings/account" params={params} replace />;
}
